__turbopack_context__.v({
  "Container": "k1nDqa_Container",
  "Content": "k1nDqa_Content",
  "FileSize": "k1nDqa_FileSize",
  "Format": "k1nDqa_Format",
  "IconWrapper": "k1nDqa_IconWrapper",
  "Root": "k1nDqa_Root",
  "Text": "k1nDqa_Text",
  "Title": "k1nDqa_Title",
  "skeleton-loading": "k1nDqa_skeleton-loading",
});
